import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { SimpleModal } from '../../ui-components/modals/SimpleModal'
import { Sanitized } from '../../features/search/Results/utils/Sanitized'
import { Translate } from 'common'
import { useUiStateStore } from '../uiState/UiStateStore'
import { DuplicateVehicleActions } from '../../ui-components/util/Interfaces'
import { formatVehicleDisplay } from 'src/helpers/utils'

const DuplicateVehicleModal = observer((): ReactElement => {
  const uiStore = useUiStateStore()
  const { promise, vehicle } = uiStore.duplicateVehicleModalParams || {}
  const vehicleName = formatVehicleDisplay(vehicle)
  const boldVehicleName = `<b>${vehicleName}</b>`

  return (
    <SimpleModal
      title="duplicateVehicle"
      primaryActionText="startNewCart"
      secondaryActionText="mergeWithExistingCart"
      onPrimaryAction={() => {
        promise.resolve(DuplicateVehicleActions.START_NEW)
      }}
      onSecondaryAction={() => {
        promise.resolve(DuplicateVehicleActions.MERGE)
      }}
      onCancel={() => {
        promise.reject(DuplicateVehicleActions.CANCEL)
      }}
      disablePrimaryButton={false}
      show={uiStore.showDuplicateVehicleModal}
    >
      <Sanitized
        html={Translate('existingCartWarningModal', [boldVehicleName])}
      />
    </SimpleModal>
  )
})

export default DuplicateVehicleModal
